export const NotFoundPage = () => {
  return <div>Not Found</div>;
};
